import { PreviewPanelAris } from './ConfluencePreviewPanelTypes';

export const isPreviewPanelAvailable = ({ ari }: { ari: string }) => {
	if (PreviewPanelAris.goal.test(ari)) {
		return true;
	}

	return false;
};
